import { Button } from "@aviary";
import { TypeaheadBold } from "@shared/components/Typeahead/TypeaheadBold/TypeaheadBold";

import * as styles from "./TypeaheadRow.styles";

interface Props {
  query: string;
  name: string;
  brandName?: string;
  onClick: () => void;
  isHighlighted: boolean;
}

const TypeaheadRow = ({ query, name, brandName, onClick, isHighlighted }: Props) => {
  const getBrandName = () => {
    if (brandName) {
      const text = ` (${brandName})`;

      return <span css={styles.brandName}>{text}</span>;
    }
  };

  const buttonStyles = [styles.row, isHighlighted ? styles.highlightRow : undefined];

  return (
    <Button isText isColor="system" css={buttonStyles} onClick={onClick}>
      <TypeaheadBold queryText={query} typeaheadSuggestionText={name} />
      {getBrandName()}
    </Button>
  );
};

export { TypeaheadRow };
